export default "__VITE_ASSET__d7606f30__"